<template>
  <div class="page">
    <el-row>
      <el-col :xl="12" :lg="24" :xs="24">
        <el-form ref="form" :model="form" :rules="rule" label-width="100px" class="edit-form">
          <el-form-item label="应用名" prop="appName">
            <el-input :maxlength="20" v-model="form.appName"></el-input>
          </el-form-item>
          <el-form-item label="国内/海外应用" prop="is_overseas">
            <el-radio-group v-model="form.is_overseas" :disabled="true">
              <el-radio label="0" border>国内</el-radio>
              <el-radio label="1" border>海外</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="上架状态" prop="now_status">
            <el-radio-group v-model="form.now_status">
              <el-radio label="1" border>上架</el-radio>
              <el-radio label="0" border>下架</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="选择平台" prop="system">
            <el-radio-group v-model="form.system">
              <el-radio v-for="(v, i) in systemOpt" :label="v.value" :key="i" :disabled="true" border>{{ v.name
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="平台手续费" prop="subscribe_rate"
            v-if="(form.system == 1 || form.system == 2) && form.is_overseas == '1'">
            <div class="flx">
              <div class="select_box">
                <span style="margin-right: 10px;">订阅手续费</span>
                <el-select v-model="form.subscribe_rate" filterable placeholder="请选择" style="width: 200px;">
                  <el-option label="15%" :value="15"></el-option>
                  <el-option label="30%" :value="30"></el-option>
                </el-select>
              </div>
              <div class="select_box">
                <span style="margin-right: 10px;">商品手续费</span>
                <el-select v-model="form.goods_rate" filterable placeholder="请选择" style="width: 200px;">
                  <el-option label="15%" :value="15"></el-option>
                  <el-option label="30%" :value="30"></el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="更新时间"
            :prop="(form.system == 1 || form.system == 2) && form.is_overseas == '1' ? 'take_effect_time' : ''"
            v-show="(form.system == 1 || form.system == 2) && form.is_overseas == '1'">
            <el-date-picker v-model="form.take_effect_time" value-format="yyyyMMdd" type="date"
              :picker-options="pickerTakeEffectTimeOptions" placeholder="更新时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="包名" :prop="form.system == '6'?'':'package_name'" v-if="form.system == '1' || form.system == '2' || form.system == '6'">
            <el-input v-model.trim="form.package_name" disabled></el-input>
          </el-form-item>
          <el-form-item label="OAID证书" prop="secret_key" v-if="form.system == '1' || form.system == '6'">
            <el-input type="textarea" :rows="5" v-model="form.secret_key"></el-input>
          </el-form-item>
          <el-form-item label="证书到期时间" prop="exp_time" v-if="form.system == '1' || form.system == '6'">
            <el-date-picker v-model="form.exp_time" type="date" placeholder="选择日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="小程序appid" prop="mini_appid" v-if="form.system == '3' || form.system == '4'">
            <el-input v-model.trim="form.mini_appid" disabled></el-input>
          </el-form-item>
          <el-form-item label="app_secret" prop="mini_secret" v-if="form.system == '3' || form.system == '4'">
            <el-input v-model="form.mini_secret" style="width:665px"></el-input> <el-tooltip style="margin-left: 10px;" class="tool_tip_item" effect="dark"
              content="小程序appid和secret在对应小程序开发者平台获取" placement="top-start">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="选择事业群" prop="department_id">
            <el-radio-group v-model="form.department_id" @change="onChangeDepartment" disabled>
              <el-radio :label="v.id" :key="i" v-for="(v, i) in department" border>{{ v.title }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="选择项目组" prop="group_id">
            <el-select v-model="form.group_id" placeholder="请选择部门" @change="onChangeProjectList" filterable disabled>
              <el-option v-for="item in group" :key="item.id" :value="item.id" :label="item.title"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择项目" prop="project_id">
            <el-select :popper-append-to-body="false" v-model="form.project_id" placeholder="请选择部门" filterable
              disabled>
              <el-option v-for="item in ProjectList" :key="item.id" :value="item.id" :label="item.title"></el-option>
            </el-select>
            <div class="item-tip">
              (如没有对应的事业群、部门、项目请联系中台新增)
            </div>
          </el-form-item>
          <el-form-item label="备注描述" prop="adminName">
            <el-input v-model.trim="form.note" type="textarea" :rows="4"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">立即编辑</el-button>
            <el-button type="danger" @click="back">取消编辑</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ElRadio from "element-ui/packages/radio/src/radio";
import moment from "moment";

export default {
  components: {
    ElRadio,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() + 3600 * 1000 * 24 * 9;
        },
      },
      pickerTakeEffectTimeOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        },
      },
      form: {
        appName: "",
        secret_key: "",
        exp_time: "",
        system: "",
        note: "",
        id: "",
        mini_appid: "",
        mini_secret: "",
        subscribe_rate: "",
        goods_rate: "",
        take_effect_time: '',
        department_id: "",
        group_id: "",
        project_id: "",
        now_status:""
      },
      formCopy: {},
      rule: {
        appName: [
          {
            required: true,
            message: "请输入应用名",
            trigger: "blur",
          },
        ],
        package_name: [
          {
            required: true,
            message: "请输入包名",
            trigger: "blur",
          },
        ],
        secret_key: [
          {
            required: true,
            message: "请输入证书秘钥",
            trigger: "blur",
          },
        ],
        exp_time: [
          {
            required: true,
            message: "请输入证书到期时间",
            trigger: "blur",
          },
        ],
        /*  subscribe_rate: [
           {
             required: true,
             validator: (rule, value, callback) => {
               console.log(this.form.subscribe_rate, this.form.goods_rate);
               if (!this.form.subscribe_rate && !this.form.goods_rate) {
                 callback(new Error('请输入平台手续费'));
               }
               if (!this.form.subscribe_rate) {
                 callback(new Error('请输入订阅手续费'));
               }
               if (!this.form.goods_rate) {
                 callback(new Error('请输入商品手续费'));
               }
               callback();
             },
             trigger: ['change', 'blue'],
           },
         ], */
        mini_secret: [
          {
            required: true,
            message: "请输入app_secret",
            trigger: "blur",
          },
        ],
        system: [
          {
            required: true,
            message: "请选择平台",
            trigger: "blur",
          },
        ],
        department_id: [
          {
            required: true,
            message: "请选择事业群",
            trigger: "blur",
          },
        ],
        group_id: [
          {
            required: true,
            message: "请选择部门",
            trigger: "blur",
          },
        ],
        take_effect_time: [
          {
            required: true,
            message: "请选择生效时间",
            trigger: "change",
          },
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "blur",
          },
        ],
      },
      systemOpt: [
        {
          name: "Android",
          value: '1',
        },
        {
          name: "iOS",
          value: '2',
        },
        {
          name: "微信小程序",
          value: "3",
        },
        {
          name: "抖音小程序",
          value: "4",
        },
        {
          name: "Web网页",
          value: "5",
        },
        {
          name: "HarmonyOS",
          value: "6",
        },
      ],
      department: [],
      group: [],
      ProjectList: [],
    };
  },
  mounted() {
    this.fetchDetail();
  },
  computed: {
    ...mapState({
      tableData: (state) => state.user_manage.list,
    }),
  },
  methods: {
    ...mapActions(["addAppManage", "getAppManage", "getApp"]),
    async fetchDetail() {
      const { form } = this;
      const { id } = this.$route.query;

      const [err, res] = await this.getAppManage({
        appId: id,
      });

      if (err) return;
      let conf = JSON.parse(res.conf) ? JSON.parse(res.conf) : {}

      this.form = {
        ...form,
        ...res,
        mini_appid: conf ? conf.appid : '',
        mini_secret: conf ? conf.secret : '',
      };

      this.form.exp_time = res.exp_time ? moment(res.exp_time).format("YYYY-MM-DD") : ""
      this.formCopy = JSON.parse(JSON.stringify({
        ...this.form,
      }))
      this.onFetchDepartment();
    },
    async onFetchDepartment() {
      const [err, res] = await this.$http.post(
        "/Apartment_Manage/getDepartment"
      );

      if (err) return;

      this.department = res;
      const currentDepartment = this.department.filter(
        (v) => v.id === this.form.department_id
      );
      this.group = currentDepartment ? currentDepartment[0].groups : [];

      const projectList = this.group.filter((v) => v.id === this.form.group_id);
      this.ProjectList = projectList ? projectList[0].projects : [];
    },
    onChangeDepartment(val) {
      const currentDepartment = this.department.filter((v) => v.id === val);

      this.group = currentDepartment ? currentDepartment[0].groups : [];
    },
    onChangeProjectList(val) {
      const projectList = this.group.filter((v) => v.id === val);
      this.ProjectList = projectList ? projectList[0].projects : [];
    },
    async onSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) return false;

        const { form } = this;
        const appId = form.id;
        this.form.exp_time = moment(this.form.exp_time).format("YYYY-MM-DD");
        let nowForm
        if (this.form.subscribe_rate == this.formCopy.subscribe_rate && this.form.goods_rate == this.formCopy.goods_rate && this.form.take_effect_time == this.formCopy.take_effect_time) {
          nowForm = true
        } else {
          nowForm = false
        }
        const [err, res] = await this.addAppManage({
          ...form,
          appId,
          subscribe_rate: nowForm ? '' : this.form.subscribe_rate,
          goods_rate: nowForm ? '' : this.form.goods_rate,
          take_effect_time: nowForm ? '' : this.form.take_effect_time,
        });

        if (err) {
          return;
        }

        this.$notify.success({
          title: "提示",
          message: "编辑成功",
        });

        this.getApp();
        this.$router.push("/manage_center/framework");
      });
    },
    back() {
      this.$router.push({
        name: 'manage_center_framework',
        params: {
          index_tab: 4,
        },
      })
    }
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  background-color: #fff;
  padding: 50px 20px;

  .edit-form {
    .el-select {
      width: 100%;
    }
  }
}

.flx {
  display: flex;
  justify-content: space-between;

  .select_box {
    padding: 20px;
    border: 1px solid #c9c9c9;
    border-radius: 10px;
  }
}
</style>
